export default __webpack_public_path__ + "static/media/029-librarian.856420ee.svg";